// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AnswersController from "./answers_controller";
application.register("answers", AnswersController);

import CardsController from "./cards_controller";
application.register("cards", CardsController);

import ConfirmationController from "./confirmation_controller";
application.register("confirmation", ConfirmationController);

import CookieController from "./cookie_controller";
application.register("cookie", CookieController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import FormSubmissionController from "./form_submission_controller";
application.register("form-submission", FormSubmissionController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import HeroController from "./hero_controller";
application.register("hero", HeroController);

import LightboxController from "./lightbox_controller";
application.register("lightbox", LightboxController);

import QuestionsController from "./questions_controller";
application.register("questions", QuestionsController);

import StudyguideController from "./studyguide_controller";
application.register("studyguide", StudyguideController);

import AiQuestionsController from "./ai_questions_controller";
application.register("ai-questions", AiQuestionsController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);
